import { render, staticRenderFns } from "./ViewHistoryDetails.vue?vue&type=template&id=75442646"
import script from "./ViewHistoryDetails.vue?vue&type=script&lang=js"
export * from "./ViewHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewHistoryDetails.vue?vue&type=style&index=0&id=75442646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports